import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class OrderNotReceivedReply extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'OrderNotReceivedReply';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.orderNotReceivedReply, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setOrderNotReceived(true));
    }
}


export default OrderNotReceivedReply;